import React, { lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { RELATIVE_ROUTES, ROUTES } from "@/constants/RouteConstants";
import ErrorBoundaryLayout from "@/components/ErrorBoundary/ErrorBoundaryLayoyt";

const PageNotFound = lazy(() => import("@/views/PageNotFound/PageNotFound"));

const LandingLayout = lazy(
  () => import("@/Layouts/LandingLayout/LandingLayout"),
);
const ProtectedRoutes = lazy(() => import("@/Routes/ProtectedRoutes"));
const MainLayout = lazy(() => import("@/Layouts/MainLayout/MainLayout"));

const CandidateLogin = lazy(
  () => import("@/views/Login/CandidateLogin/CandidateLogin"),
);
const Landing = lazy(() => import("@/views/Login/Landing/Landing"));

const Redirect = lazy(() => import("@/views/Redirect/Redirect"));
const Lobby = lazy(() => import("@/views/Lobby/Lobby"));
const InterviewSetup = lazy(
  () => import("@/views/InterviewSetup/InterviewSetup"),
);
const Library = lazy(() => import("@/views/Library/Library"));
const TabView = lazy(() => import("@/views/TabView/TabView"));
const InterviewFeedback = lazy(
  () => import("@/views/InterviewFeedback/InterviewFeedback"),
);
const DoSelectFeedback = lazy(
  () => import("@/views/DoSelectFeedback/DoSelectFeedback"),
);

const {
  ACCESS_ROUTE,
  ADD_QUESTION_ROUTE,
  CANDIDATE_LOGIN_ROUTE,
  CANDIDATE_WAIT_ROUTE,
  IMPORT_QUESTION_ROUTE,
  INTERVIEW_ROUTE,
  NOT_FOUND_ROUTE,
  QUESTION_ROUTE,
  STAR_ROUTE,
  CREATED_IMPORT_QUESTIONS_ROUTE,
  SSO_AUTH_ROUTE,
  ACCESS_TOKEN_AUTH_ROUTE,
} = RELATIVE_ROUTES;

const {
  DOSELECT_FEEDBACK_ROUTE,
  INTERVIEW_FEEDBACK_ROUTE,
  REDIRECTION_ROUTE,
  INTERVIEW_FEEDBACK_REVISION_ROUTE,
  DOSELECT_FEEDBACK_REVISION_ROUTE,
} = ROUTES;

const router = createBrowserRouter([
  {
    element: <ErrorBoundaryLayout />,
    children: [
      {
        path: "*",
        element: <PageNotFound />,
        loader: () => true,
      },
      {
        path: NOT_FOUND_ROUTE,
        element: <PageNotFound />,
        loader: () => true,
      },
      {
        path: ACCESS_ROUTE,
        element: <LandingLayout />,
        children: [
          {
            path: CANDIDATE_LOGIN_ROUTE,
            element: <CandidateLogin />,
          },
          {
            path: "",
            element: <Landing />,
          },
        ],
      },
      {
        path: SSO_AUTH_ROUTE,
        element: <Redirect isSsoAuth isTokenAuth={false} />,
      },
      {
        path: REDIRECTION_ROUTE,
        element: <Redirect isSsoAuth isTokenAuth={false} />,
      },
      {
        path: ACCESS_TOKEN_AUTH_ROUTE,
        element: <Redirect isSsoAuth={false} isTokenAuth />,
      },
      {
        path: INTERVIEW_ROUTE,
        element: (
          <ProtectedRoutes>
            <MainLayout />
          </ProtectedRoutes>
        ),
        children: [
          {
            path: STAR_ROUTE,
            element: <PageNotFound key={STAR_ROUTE} />,
          },
          {
            path: ADD_QUESTION_ROUTE,
            element: <InterviewSetup key={ADD_QUESTION_ROUTE} />,
          },
          {
            path: CANDIDATE_WAIT_ROUTE,
            element: <InterviewSetup key={CANDIDATE_WAIT_ROUTE} />,
          },
          {
            path: IMPORT_QUESTION_ROUTE,
            element: <Library key={IMPORT_QUESTION_ROUTE} />,
          },
          {
            path: QUESTION_ROUTE,
            element: <TabView key={QUESTION_ROUTE} />,
          },
          {
            path: CREATED_IMPORT_QUESTIONS_ROUTE,
            element: <Library key={CREATED_IMPORT_QUESTIONS_ROUTE} />,
          },
          {
            path: "",
            element: <Lobby key="lobby" />,
          },
        ],
      },
      {
        path: INTERVIEW_FEEDBACK_ROUTE,
        element: (
          <ProtectedRoutes>
            <InterviewFeedback
              key={INTERVIEW_FEEDBACK_ROUTE}
              isRevisionFlow={false}
            />
          </ProtectedRoutes>
        ),
      },
      {
        path: INTERVIEW_FEEDBACK_REVISION_ROUTE,
        element: (
          <ProtectedRoutes>
            <InterviewFeedback
              key={INTERVIEW_FEEDBACK_REVISION_ROUTE}
              isRevisionFlow
            />
          </ProtectedRoutes>
        ),
      },
      {
        path: DOSELECT_FEEDBACK_ROUTE,
        element: (
          <ProtectedRoutes>
            <DoSelectFeedback
              key={DOSELECT_FEEDBACK_ROUTE}
              isRevisionFlow={false}
            />
          </ProtectedRoutes>
        ),
      },
      {
        path: DOSELECT_FEEDBACK_REVISION_ROUTE,
        element: (
          <ProtectedRoutes>
            <DoSelectFeedback
              key={DOSELECT_FEEDBACK_REVISION_ROUTE}
              isRevisionFlow
            />
          </ProtectedRoutes>
        ),
      },
    ],
  },
]);

function Routes() {
  return <RouterProvider router={router} />;
}

export default Routes;
